import Reveal from "@/components/Reveal";
import { FriendlyBadges } from "@/components/FriendlyBadges";
import { useLang } from "@/i18n";
import { useContent } from "@/content/ContentContext";

const LocaleSection = () => {
  const { t } = useLang();
  const l = t.locale;
  const img = useContent().images.locale;

  return (
    <section id="locale" className="py-24 md:py-40 overflow-hidden" data-testid="locale-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-end">
          <div className="md:col-span-7">
            <Reveal>
              <p className="eyebrow text-olive mb-7">{l.label}</p>
              <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight max-w-2xl">
                {l.title}
              </h2>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="mt-10 text-base md:text-lg font-light leading-relaxed text-anthracite/85 max-w-lg">
                {l.p1}
              </p>
              <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-anthracite/85 max-w-lg">
                {l.p2}
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.15} className="md:col-span-5">
            <div className="frame">
              <img
                src={img.facade}
                data-edit-img="locale.facade"
                alt={l.altFacade}
                loading="lazy"
                className="w-full aspect-[3/4] object-cover"
              />
            </div>
          </Reveal>
        </div>

        <div className="mt-24 md:mt-36 grid md:grid-cols-12 gap-10 items-start">
          <Reveal className="md:col-span-7 relative">
            <div className="frame">
              <img
                src={img.room}
                data-edit-img="locale.room"
                alt={l.altRoom}
                loading="lazy"
                className="w-full aspect-[4/3] object-cover"
              />
            </div>
            <div className="hidden md:block absolute -bottom-16 -right-10 w-2/5 border-8 border-ivory shadow-2xl shadow-anthracite/15">
              <img
                src={img.corner}
                data-edit-img="locale.corner"
                alt={l.altCorner}
                loading="lazy"
                className="w-full aspect-[3/4] object-cover"
              />
            </div>
          </Reveal>
          <Reveal delay={0.15} className="md:col-span-4 md:col-start-9 md:mt-24">
            <p className="text-base md:text-lg font-light leading-relaxed text-anthracite/85">
              {l.p3}
            </p>
            <span className="block mt-8 w-12 h-px bg-bordeaux/60" aria-hidden="true" />
          </Reveal>
        </div>

        <Reveal className="mt-28 md:mt-44">
          <div
            className="bg-bordeaux text-ivory grid md:grid-cols-12 items-stretch"
            data-testid="welcome-panel"
          >
            <div className="md:col-span-5 overflow-hidden">
              <img
                src={img.welcome}
                data-edit-img="locale.welcome"
                alt={l.altCouple}
                loading="lazy"
                className="w-full h-full max-h-[520px] md:max-h-none aspect-[4/5] md:aspect-auto object-cover object-center"
              />
            </div>
            <div className="md:col-span-7 p-8 md:p-16 lg:p-20 flex flex-col justify-center">
              <p className="eyebrow text-sand mb-7">{l.welcomeLabel}</p>
              <p className="font-serif text-2xl md:text-4xl lg:text-5xl leading-[1.15] tracking-tight">
                {l.welcomeText}
              </p>
              <p className="mt-8 font-serif italic text-lg md:text-xl text-sand">— U Magazin</p>
              <FriendlyBadges tone="text-sand" className="mt-10 pt-8 border-t border-sand/25" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default LocaleSection;
